import { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import axios from "axios";

import qs from "qs";

export const REST_ERROR_DETAILS_STRING_FRAGMENT = "Szczegóły:";
export const TOAST_ERROR = "Wystąpił błąd.";

const getErrorMessageText = (errorMessage) => {
  if (!errorMessage) return "";

  const errorMessageRows = errorMessage.split("\n");
  const errorMessageDetails = errorMessageRows.filter((text) =>
    text.includes(REST_ERROR_DETAILS_STRING_FRAGMENT)
  );

  const errorMessageContainsDetails = !!errorMessageDetails[0];

  const splitStartIndex = REST_ERROR_DETAILS_STRING_FRAGMENT.length;

  return errorMessageContainsDetails
    ? errorMessageDetails[0].slice(splitStartIndex).trim()
    : errorMessage;
};

export const useFetch = ({
  url,
  config,
  isShowToast = true,
  skip = false,
  queryParams,
  onCompleted,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const requestUrl = queryParams
    ? `/${url}?${qs.stringify(queryParams, { allowDots: true })}`
    : url;

  const fetchData = async (requestUrl) => {
    try {
      setLoading(true);
      const res = await axios.get(requestUrl, config);

      if (!!onCompleted) {
        onCompleted(res.data);
      }
    } catch (error) {
      const message = error.response.data.errors.message[0] || "";

      const requestErrorMessage = getErrorMessageText(message) || TOAST_ERROR;

      setErrorMessage(requestErrorMessage);

      if (isShowToast) {
        toastr.error("errorMessage");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!skip) {
      fetchData(requestUrl);
    }
  }, [requestUrl, skip]);

  return { errorMessage, loading };
};
